import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { redeemCoupon } from "../../services/coupon";
import { getMe } from "../../store/auth-action";
import LoadingOverlay from "../Ui/LoadingOverlay";

const RedeemCode = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [formValue, setFormValue] = useState({
    code: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prevState) => ({
      ...prevState,
      [name]: value?.toUpperCase(),
    }));
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    const callRedeemCode = async () => {
      setLoading(true);
      try {
        const response = await redeemCoupon(formValue.code?.toUpperCase());
        setTimeout(() => {
          setLoading(false);
          dispatch(getMe());
        });
        console.log(response.data);
        toast.success(response.data?.message || "Successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callRedeemCode();
  };

  return (
    <div>
      {loading && <LoadingOverlay />}
      <div className="space-y-6 flex justify-center items-center">
        <form onSubmit={onSubmitHandler} className="space-y-2">
          <h3>🎁 Enter a gift code to unlock more extra sermons</h3>
          <div className="w-full md:w-auto">
            <label
              htmlFor="nickname"
              className="block mb-2 text-sm font-medium text-gray-900 text-start"
            >
              {/* Coupon Code: */}
            </label>
            <input
              type="text"
              name="code"
              value={formValue?.code}
              onChange={handleChange}
              id="code"
              required
              placeholder="Code"
              className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
          </div>
          <button
            disabled={loading}
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default RedeemCode;
